module.exports = __webpack_public_path__ + "static/media/bahrain.fa319fdf.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/bahrain.png
// module id = 44
// module chunks = 0